import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { styled } from 'dripsy';
import { View } from 'react-native';

import { useTagsModel } from '@models/Tags/TagsModel';
import { BaseText } from '../common/BaseText';
import { Separator } from '../common/Separator';
import {
  ITagItemSelectableProps,
  TagItemSelectable,
} from './TagItemSelectable';

const Container = styled(View)({});

const TagsListContainer = styled(View)({
  flexDirection: 'row',
  flexWrap: 'wrap',
});
const RowContainer = styled(View)({
  flexDirection: 'row',
  mb: '$5',
});

const TextLabel = styled(BaseText)({
  color: '$heading800',
  variant: 'text.xlarge',
});

export interface IHubTagsContainerProps
  extends Pick<ITagItemSelectableProps, 'onPress'> {}

export const HubTagsContainer = observer(
  ({ onPress }: IHubTagsContainerProps) => {
    const { t } = useTranslation();
    const tags = useTagsModel();

    const isEmptyTags = tags.recommended.isEmpty;

    return (
      <Container>
        <Separator size="$8" />
        {isEmptyTags && <TextLabel>{t('tags.title')}</TextLabel>}
        <Separator size="$6" />
        <TagsListContainer>
          {tags.recommended.asArray.map((tag) => (
            <RowContainer key={tag.id}>
              <TagItemSelectable item={tag} onPress={onPress} />
              <Separator vertical size="$4" />
            </RowContainer>
          ))}
        </TagsListContainer>
      </Container>
    );
  },
);
